import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Grid, Typography, Paper, Button } from '@mui/material';
import { Favorite as FavoriteIcon } from '@mui/icons-material';
import { RootState } from '../../store';
import { removeFromFavorites } from '../../store/favoritesSlice';
import GameCard from '../../components/GameCard/GameCard';
import { Game } from '../../types/game';

const Favorites: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const favorites = useSelector((state: RootState) => state.favorites.items);

  const handleFavoriteToggle = (game: Game) => {
    dispatch(removeFromFavorites(game.id));
  };

  const handleGameClick = (gameId: number) => {
    navigate(`/game/${gameId}`);
  };

  if (favorites.length === 0) {
    return (
      <Paper elevation={3} style={{ padding: '3rem', textAlign: 'center' }}>
        <FavoriteIcon style={{ fontSize: 60, color: '#ccc', marginBottom: '1rem' }} />
        <Typography variant="h5" gutterBottom>
          У вас пока нет избранных игр
        </Typography>
        <Typography variant="body1" paragraph color="textSecondary">
          Добавьте игры в избранное, чтобы они появились здесь
        </Typography>
        <Button variant="contained" color="primary" onClick={() => navigate('/games')}>
          Перейти к каталогу
        </Button>
      </Paper>
    );
  }

  return (
    <div>
      <Typography variant="h4" component="h1" gutterBottom>
        Избранные игры
      </Typography>
      <Typography variant="body1" paragraph color="textSecondary">
        Всего игр: {favorites.length}
      </Typography>
      
      <Grid container spacing={3}>
        {favorites.map((game) => (
          <Grid item xs={12} sm={6} md={4} key={game.id}>
            <GameCard
              game={game}
              isFavorite={true}
              onFavoriteToggle={handleFavoriteToggle}
              onClick={() => handleGameClick(game.id)}
            />
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default Favorites;